module.exports = __webpack_public_path__ + "img/grinded.a6311ee3.png";